import { useContext } from "react"
import { AnalyticsContext, AnalyticsContextData } from "../contexts/analytics.context"

const useAnalytics = (): AnalyticsContextData => {
  return useContext(AnalyticsContext)
}

export { useAnalytics }
